import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";

const DEFAULT_TITLE = "Wishliz - Smart Wishlist App";

// Only the <title> is managed client-side. og:*/twitter:*/description tags stay
// static in public/index.html since non-JS social crawlers never see this component.
const Seo = ({ title }) => {
    const fullTitle = title
        ? title.includes("Wishliz")
            ? title
            : `${title} | Wishliz`
        : DEFAULT_TITLE;

    return (
        <Helmet>
            <title>{fullTitle}</title>
        </Helmet>
    );
};

Seo.propTypes = {
    title: PropTypes.string,
};

export default Seo;
